import { IProfilePictureService } from '@nimbus-library/features/user-settings/services/contracts/i-profile-picture.service';

export class DefaultProfilePictureService extends IProfilePictureService {
  public getUserProfilePicture(tenantId: string, userId: string): string {
    return null;
  }
}
